<template>

  <div class="form-group">
    <label
      v-if="label"
      :for="id"
    >{{ label }} <span v-if="required">*</span>
      <Hint
        v-if="hint"
        :textHint="hint"
        :bgColor="hintBgColor"
        :image="hintImage"
        :description="hintDescription"
      />:
    </label>
    <div class="flex items-center">
      <select
        v-bind="$attrs"
        :id="id"
        :type="type"
        :value="value"
        :placeholder="label"
        @change="$emit('change', $event.target.value)"
      >
        <option :value="0">Тип элемента не выбран</option>
        <option
          v-for="option in options"
          :key="option.data.option_id"
          :value="option.data.option_id"
        >
          {{ option.data.attributes.name }}
        </option>
      </select>
    </div>
    <ValidationErrors :errors="errors" />
  </div>
</template>
<script>
export default {
  props: {
    id: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "text",
    },
    value: {
      type: [String, Number],
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    errors: {
      type: Array,
      default: () => [],
    },
    hint: {
      type: String,
      default: "",
    },
    hintBgColor: {
      type: String,
      default: "",
    },
    hintImage: {
      type: String,
      default: "",
    },
    hintDescription: {
      type: String,
      default: "",
    },
  },
};
</script>
